import React, { FC } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Spacer } from '../spacer/Spacer';
import { Typography } from '../typography/Typography';

// Interface

export interface QuoteProps {
  centered?: boolean;
  text: string;
  quoteName?: string;
  position?: string;
  company?: string;
}

export interface StyledQuoteProps {
  centered?: boolean;
}

// Styles

const StyledQuote = styled(Spacer)<StyledQuoteProps>`
  ${({ theme: { space, colors, media }, centered }) => css`
    ${centered &&
    css`
      text-align: center;
      margin-right: auto;
      margin-left: auto;
    `};
  `};
`;

// JSX

export const Quote: FC<QuoteProps> = ({
  text,
  quoteName,
  position,
  company,
  centered,
}) => (
  <StyledQuote as="figure" centered={centered}>
    <blockquote>
      <Typography variant="quote" component="p">
        &ldquo;{text}&rdquo;
      </Typography>
    </blockquote>
    {quoteName && (
      <figcaption>
        {quoteName && (
          <>
            <strong>{quoteName}</strong>
            <br />
          </>
        )}
        {position && (
          <>
            {position}
            <br />
          </>
        )}
        {company && <>{company}</>}
      </figcaption>
    )}
  </StyledQuote>
);

export default Quote;
